import commonConstant from '../../common/_commonConstant';
import { checkTimeToRefreshToken, getCookieToken } from '../../common/_commonFunction';
import { history } from '../../helpers';
import { fetchRefreshToken } from '../../actions';

export const fetchGetAccountingReports = (buildingRefNo, vehicleLicensePlates, hasRedemption, paymentMethods, from, to, limit, offset, sortBy, orderBy, vehicleTypes, hasFines, parkingRefNos) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/reports/accounting-report?buildingRefNo=${buildingRefNo ? buildingRefNo : ''}${vehicleLicensePlates ? `&vehicleLicensePlates=${vehicleLicensePlates}` : ''}${hasRedemption || hasRedemption === false ? `&hasRedemption=${hasRedemption}` : ''}${paymentMethods ? `&paymentMethods=${paymentMethods}` : ''}${from ? `&from=${from}` : ''}${to ? `&to=${to}` : ''}&offset=${offset || offset >= 0 ? offset : ''}&limit=${limit ? limit : ''}&sortBy=${sortBy ? sortBy : ''}&orderBy=${orderBy ? orderBy : ''}${vehicleTypes ? `&vehicleTypes=${vehicleTypes}` : ''}${hasFines || hasFines === false ? `&hasFines=${hasFines}` : ''}${parkingRefNos ? `&parkingRefNos=${parkingRefNos}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_ACCOUNTING_REPORT_SUCCESS,
          'data': data.data ? data.data : [],
          'metadata': data.metadata ? data.metadata : {},
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_ACCOUNTING_REPORT_FAILURE,
        'data': null,
        'metadata': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_ACCOUNTING_REPORT_FAILURE,
        'data': null,
        'metadata': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchExportAccountingReports = (buildingRefNo, from, to) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/exports/accounting-report?buildingRefNo=${buildingRefNo ? buildingRefNo : ''}${from ? `&from=${from}` : ''}${to ? `&to=${to}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const blob = await res.blob();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.EXPORT_ACCOUNTING_REPORT_SUCCESS,
          'status': res.status,
          blob,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': null,
      });
      return dispatch({
        'type': commonConstant.EXPORT_ACCOUNTING_REPORT_FAILURE,
        'status': res.status ? res.status : res,
        'blob': null,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.EXPORT_ACCOUNTING_REPORT_FAILURE,
        'status': err.status ? err.status : err,
        'blob': null,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchGetParkingReport = (buildingRefNo, vehicleLicensePlates, parkingStatus, createdBy, problemCodes, from, to, limit, offset, sortBy, orderBy, vehicleTypes, customerTypes, parkingRefNos) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/reports/parking-report?buildingRefNo=${buildingRefNo ? buildingRefNo : ''}${vehicleLicensePlates ? `&vehicleLicensePlates=${vehicleLicensePlates}` : ''}${parkingStatus ? `&parkingStatus=${parkingStatus}` : ''}${createdBy ? `&createdBy=${createdBy}` : ''}${problemCodes ? `&problemCodes=${problemCodes}` : ''}${from ? `&from=${from}` : ''}${to ? `&to=${to}` : ''}&offset=${offset || offset >= 0 ? offset : ''}&limit=${limit ? limit : ''}&sortBy=${sortBy ? sortBy : ''}&orderBy=${orderBy ? orderBy : ''}${vehicleTypes ? `&vehicleTypes=${vehicleTypes}` : ''}${customerTypes ? `&customerTypes=${customerTypes}` : ''}${parkingRefNos ? `&parkingRefNos=${parkingRefNos}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_PARKING_REPORT_SUCCESS,
          'data': data.data ? data.data : [],
          'metadata': data.metadata ? data.metadata : {},
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_PARKING_REPORT_FAILURE,
        'data': null,
        'metadata': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_PARKING_REPORT_FAILURE,
        'data': null,
        'metadata': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchExportVehicleMovementOperationReport = (buildingRefNo, from, to, vehicleTypes, customerTypes) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/exports/vehicle-movement-report?buildingRefNo=${buildingRefNo ? buildingRefNo : ''}${from ? `&from=${from}` : ''}${to ? `&to=${to}` : ''}${vehicleTypes ? `&vehicleTypes=${vehicleTypes}` : ''}${customerTypes ? `&customerTypes=${customerTypes}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const blob = await res.blob();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.EXPORT_VEHICLE_MOVEMENT_OPERATION_REPORT_SUCCESS,
          'status': res.status,
          blob,
          'dateTime': new Date(),
          'reportType': 'vehicle_movement',
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': null,
      });
      return dispatch({
        'type': commonConstant.EXPORT_VEHICLE_MOVEMENT_OPERATION_REPORT_FAILURE,
        'status': res.status ? res.status : res,
        'blob': null,
        'dateTime': new Date(),
        'reportType': 'vehicle_movement',
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.EXPORT_VEHICLE_MOVEMENT_OPERATION_REPORT_FAILURE,
        'status': err.status ? err.status : err,
        'blob': null,
        'dateTime': new Date(),
        'reportType': 'vehicle_movement',
      });
    }
  }
);

export const fetchExportRedemptionOperationReport = (buildingRefNo, from, to, vehicleTypes) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/exports/redemption-usage-report?buildingRefNo=${buildingRefNo ? buildingRefNo : ''}${from ? `&from=${from}` : ''}${to ? `&to=${to}` : ''}${vehicleTypes ? `&vehicleTypes=${vehicleTypes}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const blob = await res.blob();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.EXPORT_REDEMPTION_OPERATION_REPORT_SUCCESS,
          'status': res.status,
          blob,
          'dateTime': new Date(),
          'reportType': 'redemption_usage',
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': null,
      });
      return dispatch({
        'type': commonConstant.EXPORT_REDEMPTION_OPERATION_REPORT_FAILURE,
        'status': res.status ? res.status : res,
        'blob': null,
        'dateTime': new Date(),
        'reportType': 'redemption_usage',
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.EXPORT_REDEMPTION_OPERATION_REPORT_FAILURE,
        'status': err.status ? err.status : err,
        'blob': null,
        'dateTime': new Date(),
        'reportType': 'redemption_usage',
      });
    }
  }
);

export const fetchExportMemberMovementOperationReport = (buildingRefNo, exportDate, vehicleTypes, membershipStatus) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/exports/membership-movement-report?buildingRefNo=${buildingRefNo ? buildingRefNo : ''}${exportDate ? `&exportDate=${exportDate}` : ''}${vehicleTypes ? `&vehicleTypes=${vehicleTypes}` : ''}${membershipStatus ? `&membershipStatus=${membershipStatus}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const blob = await res.blob();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.EXPORT_MEMBER_MOVEMENT_OPERATION_REPORT_SUCCESS,
          'status': res.status,
          blob,
          'dateTime': new Date(),
          'reportType': 'member_movement',
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': null,
      });
      return dispatch({
        'type': commonConstant.EXPORT_MEMBER_MOVEMENT_OPERATION_REPORT_FAILURE,
        'status': res.status ? res.status : res,
        'blob': null,
        'dateTime': new Date(),
        'reportType': 'member_movement',
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.EXPORT_MEMBER_MOVEMENT_OPERATION_REPORT_FAILURE,
        'status': err.status ? err.status : err,
        'blob': null,
        'dateTime': new Date(),
        'reportType': 'member_movement',
      });
    }
  }
);

export const fetchGetMembershipReport = (buildingID, membershipStatus, vehicleTypes, vehicleLicensePlatesLike, tenantNamesLike, limit, offset, sortBy, orderBy, customerNamesLike) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/reports/tenant-member-report?buildingID=${buildingID}${membershipStatus ? `&membershipStatus=${membershipStatus}` : ''}${vehicleTypes ? `&vehicleTypes=${vehicleTypes}` : ''}${vehicleLicensePlatesLike ? `&vehicleLicensePlatesLike=${vehicleLicensePlatesLike}` : ''}${tenantNamesLike ? `&tenantNamesLike=${encodeURIComponent(tenantNamesLike)}` : ''}${customerNamesLike ? `&customerNamesLike=${encodeURIComponent(customerNamesLike)}` : ''}${limit ? `&limit=${limit}` : ''}${offset ? `&offset=${offset}` : ''}${sortBy ? `&sortBy=${sortBy}` : ''}${orderBy ? `&orderBy=${orderBy}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_MEMBERSHIP_REPORT_SUCCESS,
          'data': data.data ? data.data : [],
          'metadata': data.metadata ? data.metadata : {},
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_MEMBERSHIP_REPORT_FAILURE,
        'data': null,
        'metadata': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_MEMBERSHIP_REPORT_FAILURE,
        'data': null,
        'metadata': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);
